import { createContext, useContext } from 'react';
import type { UserRole } from '@audit/shared-types';

/**
 * Context that holds the current user's role, resolved once in AppLayout
 * and made available to all child components without extra API calls.
 */
export const UserRoleContext = createContext<UserRole | null>(null);

export function useUserRoleContext(): UserRole | null {
  return useContext(UserRoleContext);
}
